// extracted by mini-css-extract-plugin
export default {"title":"Yaa-z","warning":"Zaa-z","sizeOptionsLegendText":"_aa-z"};